"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M12.04 8.04h-.09l-1.6 4.55h3.29z"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m3.21 15-.98-2.81H9.78l-1 2.81h-1.9l4.13-11h1.97l4.13 11z"
}, "1")], 'HdrAutoSharp');